import { render, staticRenderFns } from "./question-content.vue?vue&type=template&id=3e308522&scoped=true"
import script from "./question-content.vue?vue&type=script&lang=js"
export * from "./question-content.vue?vue&type=script&lang=js"
import style0 from "./question-content.vue?vue&type=style&index=0&id=3e308522&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e308522",
  null
  
)

export default component.exports